import R from '../../core-res/R';
export default {
    ALERT: {
        containerStyle: {
            backgroundColor: R.color.uiYellowPrimary,
        },
        labelStyle: {
            color: R.color.uiDarkPrimary,
        },
    },
    INFO: {
        containerStyle: {
            backgroundColor: R.color.uiBlueSecondary,
        },
        labelStyle: {
            color: R.color.uiLightPrimary,
        },
    },
    INFO_SUBTLE: {
        containerStyle: {
            backgroundColor: R.color.uiBlueLight,
        },
        labelStyle: {
            color: R.color.uiBlueDark,
        },
    },
    NEGATIVE: {
        containerStyle: {
            backgroundColor: R.color.uiRedSecondary,
        },
        labelStyle: {
            color: R.color.uiLightPrimary,
        },
    },
    NEGATIVE_SUBTLE: {
        containerStyle: {
            backgroundColor: R.color.uiRedLight,
        },
        labelStyle: {
            color: R.color.uiRedDark,
        },
    },
    NEUTRAL: {
        containerStyle: {
            backgroundColor: R.color.uiDarkNeutral,
        },
        labelStyle: {
            color: R.color.uiLightSecondary,
        },
    },
    NEUTRAL_SUBTLE: {
        containerStyle: {
            backgroundColor: R.color.uiLightNeutral,
        },
        labelStyle: {
            color: R.color.uiDarkSecondary,
        },
    },
    NOTIFICATION: {
        containerStyle: {
            backgroundColor: R.color.uiOrangePrimary,
        },
        labelStyle: {
            color: R.color.uiLightPrimary,
        },
    },
    OUTLINE_BLACK: {
        containerStyle: {
            backgroundColor: 'transparent',
            borderColor: R.color.uiDarkPrimary,
            borderWidth: R.border.width.thick,
            paddingVertical: R.spacing.xxs - R.border.width.thick,
        },
        labelStyle: {
            color: R.color.uiDarkPrimary,
        },
    },
    OUTLINE_WHITE: {
        containerStyle: {
            backgroundColor: R.color.uiDarkPrimary,
            borderColor: R.color.uiLightPrimary,
            borderWidth: R.border.width.thick,
            paddingVertical: R.spacing.xxs - R.border.width.thick,
        },
        labelStyle: {
            color: R.color.uiLightPrimary,
        },
    },
    POSITIVE: {
        containerStyle: {
            backgroundColor: R.color.uiGreenSecondary,
        },
        labelStyle: {
            color: R.color.uiLightPrimary,
        },
    },
    POSITIVE_SUBTLE: {
        containerStyle: {
            backgroundColor: R.color.uiGreenLight,
        },
        labelStyle: {
            color: R.color.uiGreenDark,
        },
    },
    WARNING: {
        containerStyle: {
            backgroundColor: R.color.uiYellowSecondary,
        },
        labelStyle: {
            color: R.color.uiLightPrimary,
        },
    },
    WARNING_SUBTLE: {
        containerStyle: {
            backgroundColor: R.color.uiYellowLight,
        },
        labelStyle: {
            color: R.color.uiYellowDark,
        },
    },
};
